import HomeScreenCard from "../HomeScreenCard";
import { LuckyCardStatus } from "../../types/LuckyCardStatus";
import CardStatusBar from "../CardStatusBar";
import HomeCardTitle from "../HomeCardTitle";
import starsBackground from "@/assets/img/d_stars_background_4.png";
import cardPattern from "@/assets/img/img_card_pattern.webp";

interface LuckyCardProps {
  navigateToLuckyCard: () => void;
  luckyCardStatus: LuckyCardStatus | null;
  gridColumn: string;
  gridRow: string;
}

export const LuckyCard = ({ navigateToLuckyCard, luckyCardStatus, gridColumn, gridRow }: LuckyCardProps) => (
  <HomeScreenCard
    gridColumn={gridColumn}
    gridRow={gridRow}
    bgStyle={{
      background: `url(${starsBackground}) center/cover`,
    }}
    overlayImage=""
    onClick={() => navigateToLuckyCard()}
    style={{ cursor: "pointer" }}
    statusBar={
      luckyCardStatus?.isSubscribed && (
      <CardStatusBar
        text={luckyCardStatus?.timeToNextCard || "Доступно"}
        isAvailable={luckyCardStatus?.isAvailable || false}
        />
      )
    }
  >
        <div
      className={`p-4 sm:p-5 md:p-6 flex flex-col h-[calc(100%-30px)]`}
      style={{ zIndex: 20, cursor: "pointer" }}
    >
      <HomeCardTitle  isNeedShort={false} title="Счастливая карта" description="Победитель может задать вопрос астрологу! Удачи!" />
      <div
          style={{
            maxWidth: "100%",
            width: "100%",
            overflow: "hidden",
            borderRadius: "6px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            alignContent: "space-between",
            gap: "10px",
            padding: "5px",
          }}
        >
          <>
          <img
            src={luckyCardStatus?.selectedCard?.image ?? cardPattern}
            alt="card-back-center"
            className={`rounded-lg shadow bg-transparent`}
            style={{
              maxHeight: "70%",
              maxWidth: "70%",  
              padding: "2px",
              backgroundColor: luckyCardStatus?.selectedCard?.image ? "white" : "transparent",
              height: "auto",
              width: "auto",
              objectFit: "contain", 
              display: "block",
              zIndex: -10,
              aspectRatio: "11/19",
            }}
          />
          <img
            src={luckyCardStatus?.luckyCard?.image ?? cardPattern}
            alt="card-back-center"
            className={` rounded-lg shadow bg-transparent`}
            style={{
              maxHeight: "70% ",      
              maxWidth: "70%",  
              padding: "2px",
              backgroundColor: luckyCardStatus?.luckyCard?.image ? "white" : "transparent",
              height: "auto",
              width: "auto",
              objectFit: "contain", 
              display: "block",
              zIndex: -10,
              aspectRatio: "11/19",
            }}
          />  
          </>
      </div>
      </div>
  </HomeScreenCard>
);
